<template>
  <button
      class="
        tw-relative tw-flex tw-items-center tw-w-full
        tw-mb-small+ tw-mx-auto tw-py-20 tw-px-small+
        tw-bg-white tw-rounded-big tw-outline-0"
      @click="$emit('click')"
  >
    <img
        v-if="icon === 'email'"
        src="./../../assets/icon-email.svg" alt="edit"
        class="
        tw-mr-small+ tw-z-10

        mini:tw-hidden
        mob:tw-block"
    />

    <img
        v-if="icon === 'phone'"
        src="./../../assets/icon-phone.svg" alt="edit"
        class="
        tw-mr-small+ tw-z-10

        mini:tw-hidden
        mob:tw-block"
    />

    <img
        v-if="icon === 'bank-card'"
        src="./../../assets/icon-bank-card.svg" alt="edit"
        class="
        tw-mr-small+ tw-z-10

        mini:tw-hidden
        mob:tw-block"
    />

    <img
        v-if="icon === 'e-racun'"
        src="./../../assets/icon-e-racun.svg" alt="edit"
        class="
        tw-mr-small+ tw-z-10

        mini:tw-hidden
        mob:tw-block"
    />

    <span
        class="
          alt-label
          tw-mr-small+ tw-w-full tw-z-10
          tw-font-bold tw-text-left tw-text-tzz-blue"
    >
      {{ label }}
    </span>

    <img
        v-if="showNextIcon"
        src="./../../assets/icon-next.svg" alt="next"
        class="tw-z-10"
    />

    <span
        class="
        shadow
        tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0
        tw-rounded-big tw-z-0"
    >
    </span>
  </button>
</template>

<script>
export default {
  name: "UIButtonWithIcon",
  props: {
    icon: {
      type: String,
      validate: (value) => {
        return ['email', 'phone', 'bank-card', 'e-racun'].includes(value);
      }
    },
    label: {
      type: String,
      required: true
    },
    showNextIcon: {
      type: Boolean,
      required: false
    }
  }
}
</script>

<style scoped>
button {
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}

button:focus {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
  outline: 2px solid #1ea89c;
}

.shadow {
  background: radial-gradient(50% 50% at 50% 50%, #FFFFFF 78.12%, #F7FDFD 100%);
}

</style>
